import { ChangeEvent } from 'react';

import { SignAgreementsDto } from 'src/api/basketService';
import { OrderedList } from 'src/components/ordered-list/types';
import { LanguagesCode } from 'src/i18n/constants';
import { Currency } from 'src/shared/enum/Currency';
import { Room } from 'src/shared/types/room';
import { Building } from 'src/shared/types/building';

import { PaymentPlanDto } from '../../api/paymentPlanService/dto/PaymentPlanDto';

import { EmailValidationState } from './enum/EmailValidationState';

export enum AgreementType {
    Terms = 1,
    Licence = 2,
}

export type AgreementsPageProps = {
    room: Room;
    building: Building;
    onGoBack: () => void;
    hasRoommates: boolean;
    onSubmit: (agreementsData: SignAgreementsDto) => void | Promise<void>;
    loading: boolean;
    error: Error | null;
    adminFee?: boolean;
    isDualOccupantFlow?: boolean;
    hideBackButton: boolean;
};

export type AgreementFormState = {
    checkboxVal: boolean;
    email: string;
    validation: EmailValidationState;
    isValid: boolean;
    onCheckbox: (value: boolean) => void;
    onEmail: (e: ChangeEvent<HTMLInputElement>) => void;
};

export type AgreementsViewProps = {
    onGoBack: () => void;
    hideBackButton: boolean;
    hasRoommates: boolean;

    roomData: Room;
    currency: Currency;

    hasDiscount: boolean;
    paymentRequired: boolean;

    loading: boolean;
    error: Error | null;

    isButtonDisabled: boolean;

    terms: AgreementFormState;
    licence: AgreementFormState;

    onSubmit: () => void;
    drawer: {
        open: boolean;
        current: AgreementType;
        agreement: AgreementType;
        onClose: () => void;
        total: number;
    };

    agreements: {
        terms: React.ReactNode;
        licence: React.ReactNode;
    };
    showTermsDrawer: () => void;
    showLicenceDrawer: () => void;
    building: Building;

    paymentPlan: PaymentPlanDto;
    termDuration: number;
    termStartDate: string;
    termEndDate: string;
    numberOfStudents: number;
};

export type TermsItem = {
    header: string;
    text?: string;
    orderedList?: OrderedList[];
    intro?: string;
    outro?: string;
    bottomText?: string;
    subtitle?: string;
    introUnstyledText?: string;
};

export type BookingTermsWithLanguages = {
    languages: Record<
        LanguagesCode,
        {
            header: string;
            items: TermsItem[];
        }
    >;
};

export type BookingTerms = {
    [countryCode: string]: BookingTermsWithLanguages;
};

export enum BookingCountry {
    UK = 'united-kingdom',
    Spain = 'spain',
}
